"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultItemInUnitData = void 0;
const getScheduleSelectedIndex_1 = require("./getScheduleSelectedIndex");
const getDefaultItemInUnitData = (isArchive, unitItemsCount, rowFirstData, rowThirdData) => {
    const allUnitItems = Array.from({ length: unitItemsCount })
        .fill(undefined)
        .map(() => true);
    let itemsList = allUnitItems;
    if (!isArchive) {
        itemsList = rowFirstData;
    }
    else if (rowThirdData.some((item) => item)) {
        itemsList = rowThirdData;
    }
    const itemIndexes = getScheduleSelectedIndex_1.getScheduleSelectedIndex(itemsList);
    return itemIndexes;
};
exports.getDefaultItemInUnitData = getDefaultItemInUnitData;
//# sourceMappingURL=getDefaultItemInUnitData.js.map